import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconWhatsappBranded$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconWhatsappBranded extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '7b88efdbe8a7c999fa8b4d688894813572439c75', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '5a98e87d64dbaf6fbda8f18d8066a3a0865133bf', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '83b28ea6c3705a666b8e0ae0a4274086aa40aefe', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M17.29 4.609a8.935 8.935 0 0 0-14.05 10.79L2 20l4.702-1.251a8.94 8.94 0 0 0 4.233 1.117 8.936 8.936 0 0 0 6.356-15.257m-6.355 13.738a7.36 7.36 0 0 1-3.775-1.039l-.268-.156-2.815.737.76-2.736-.179-.29a7.3 7.3 0 0 1-1.117-3.944 7.43 7.43 0 0 1 7.394-7.416 7.417 7.417 0 0 1 7.45 7.428 7.427 7.427 0 0 1-7.45 7.416m4.077-5.585c-.223-.111-1.318-.648-1.53-.726s-.346-.111-.503.112c-.156.223-.57.726-.703.882-.134.157-.257.168-.48 0a6.2 6.2 0 0 1-1.799-1.117 7 7 0 0 1-1.24-1.552.335.335 0 0 1 .101-.458q.18-.186.335-.391.138-.169.223-.369a.4.4 0 0 0 0-.39c-.044-.056-.491-1.117-.714-1.564-.224-.447-.369-.38-.503-.38h-.391a.83.83 0 0 0-.592.28 2.5 2.5 0 0 0-.748 1.853 4.3 4.3 0 0 0 .916 2.301 10.05 10.05 0 0 0 3.808 3.351c.537.223.95.357 1.274.47.456.139.938.165 1.407.077a2.23 2.23 0 0 0 1.497-1.05c.148-.332.195-.701.134-1.06-.1-.079-.235-.135-.458-.246z", fill: "#25D366" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-whatsapp-branded", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-whatsapp-branded"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-whatsapp-branded":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconWhatsappBranded$1);
            }
            break;
    } });
}

const CosmosIconWhatsappBranded = CosmosIconWhatsappBranded$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconWhatsappBranded, defineCustomElement };
